import React, { ReactNode } from 'react';
import { Box, Tooltip } from '@mui/material';
import Chip from '@mui/material/Chip';

type DisplayWithSeeMoreChip = {
  rows: string[];
  nbRowsDisplayed: number;
  separator: string;
  prefix?: string;
};

export const DisplayWithSeeMoreChip = (props: DisplayWithSeeMoreChip) => {
  const { rows, nbRowsDisplayed, separator, prefix } = props;

  if (!rows || rows.length == 0) return '';

  if (rows.length == nbRowsDisplayed) {
    return (prefix || '') + rows.join(separator || ', ');
  } else {
    return (
      <Box display={'flex'} alignItems={'center'}>
        {prefix || ''} {rows.slice(0, nbRowsDisplayed)}
        <Tooltip sx={{ alignItems: 'center' }} title={<span style={{ whiteSpace: 'pre-wrap' }}>{rows.join(separator)}</span>}>
          <Chip sx={{ marginLeft: 0.5 }} size={'small'} label={'+' + (rows.length - nbRowsDisplayed)} />
        </Tooltip>
      </Box>
    );
  }
};
